var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',{staticClass:"width-xxx",attrs:{"size":_vm.size,"type":"month","placeholder":"选择月","value":_vm.cValue,"value-format":"yyyy-MM"},on:{"input":_vm.handleInput,"change":_vm.emitChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa047a3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/inputs/input-date-month.vue
// module id = null
// module chunks = 